
export interface IElementWithAlpha{
	element: string | any;
	alpha:boolean;
}

export const elementsAlphaConfig:IElementWithAlpha[]=[
{element:'thumb1',alpha:false},
{element:'thumb2',alpha:false},
{element:'sliderThumbLabel1',alpha:true},
{element:'sliderThumbLabel2',alpha:true},
{element:'trackFill',alpha:false}
]